import React, { ReactNode } from "react";
import type {
  AppDefinedVariables,
  Keys,
  TextComponentConfig,
} from "./textInterfaces";

import { Option as RadioOption } from "@storeblocks/radio";
import { Option as SelectOption } from "@storeblocks/select";
import { HintProps } from "Components/Form/RadioButton/radioButtonInterfaces";
import { TextComponentNameLevel1 } from "Components/TextContext/textConstants";

export interface Context {
  getText: (id: Keys, config?: TextComponentConfig) => string;
  getTexts: (
    id: Array<Keys>,
    config?: TextComponentConfig,
    separator?: string | Array<string>,
  ) => string;
  variables: AppDefinedVariables;
  updateVariables: (payload: AppDefinedVariables) => void;
  createLinkComponent: (
    id: Keys,
    config?: TextComponentConfig,
    isFormHint?: boolean,
  ) => ReactNode;
  getSelectOptions: (
    TextComponentNameLevel1: TextComponentNameLevel1,
    formFieldId: string,
    placeholder: string,
    config?: TextComponentConfig,
  ) => SelectOption[];
  getRadioOptions: (
    TextComponentNameLevel1: TextComponentNameLevel1,
    formFieldId: string,
    config?: TextComponentConfig,
    hintProps?: HintProps,
  ) => RadioOption[];
}

export const TextContext = React.createContext<Context | null>(null);
